import React from "react";
import { useStyles } from "./ContactImage.styles";
interface Props {}

export const ContactImage: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.contactImage_root}>Contact Image</div>;
};
